module.exports = __webpack_public_path__ + "07ebeb5c6be5c8f85ba2bff84abda65d.svg";